import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SectionServicesComponent } from './component/section-services.component';



@NgModule({
  declarations: [
    SectionServicesComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SectionServicesComponent
  ]
})
export class SectionServicesModule { }
